import { countryLocale, countryName } from './countries';

/** "e" replaces "y" before a word that starts with the sound i (Spanish: "México e India"). */
const SPANISH_I_SOUND = /^h?i(?!e|a[ -]|u)/i;

function conjunction(language: string, next: string): string {
  if (language !== 'es') return 'and';
  return SPANISH_I_SOUND.test(next) ? 'e' : 'y';
}

/**
 * The countries named in the offering notice, written in the reader's language and joined the
 * way that language joins a list ("Mexico and United States", "México y Estados Unidos"; three
 * or more as "A, B, and C" in English and "A, B y C" in Spanish). A code that is not a country
 * is left out: the line never prints a bare code.
 */
export function offeringCountryList(codes: readonly string[], language: string): string {
  const locale = countryLocale(language);
  const names = codes
    .map((code) => countryName(code.toUpperCase(), locale))
    .filter((name): name is string => name !== null);
  if (names.length < 2) return names.join('');
  const last = names[names.length - 1];
  const head = names.slice(0, -1);
  const comma = language !== 'es' && names.length > 2 ? ',' : '';
  return `${head.join(', ')}${comma} ${conjunction(language, last)} ${last}`;
}
